import { CUBE_AGGREGATE_INTERACTION } from '@/api/hcp/interaction/types';
import mapDimensionToOption from '@/models/filter/utils/mapDimensionToOption';
import { CubeQuery, GetOptionsQueryFunction } from '@/types/cube';
import { FilterConfig } from '@/types/filter';
import { getDateRangeTimeDimension } from '@/utils/cube';

const EMAIL_CHANNEL_OPTIONS: GetOptionsQueryFunction = ({ sourceCube, dateRange }) => {
  const timeDimensions = getDateRangeTimeDimension({
    dateRange,
    dimension: `${CUBE_AGGREGATE_INTERACTION}.interaction_date`,
  });
  const query: CubeQuery = {
    dimensions: [`${sourceCube}.email_diffusion`],
    limit: 1000,
    filters: [
      { member: `${sourceCube}.channel`, operator: 'equals', values: ['Email'] },
      { member: `${sourceCube}.hcp_bk`, operator: 'set' },
    ],
    timeDimensions: [timeDimensions],
  };
  return query;
};

const emailChannelFilter: FilterConfig = {
  label: 'main.channelFocus.hcpCoverage.filters.emailChannel.label',
  placeholder: 'main.channelFocus.hcpCoverage.filters.emailChannel.placeholder',
  clearable: true,
  type: 'multiselect',
  getOptionsQuery: EMAIL_CHANNEL_OPTIONS,
  mapResult: mapDimensionToOption(`${CUBE_AGGREGATE_INTERACTION}.email_diffusion`),
  sourceCube: CUBE_AGGREGATE_INTERACTION,
  applyFilter: value => {
    const v = value as string[];
    return {
      member: `${CUBE_AGGREGATE_INTERACTION}.email_diffusion`,
      operator: 'equals',
      values: [...v],
    };
  },
  defaultValue: [],
};

export default emailChannelFilter;
